// extracted by mini-css-extract-plugin
export default {"itemText":"SavedViewItem-module__itemText--P6U4z","icon":"SavedViewItem-module__icon--POC_c"};